@if (option().enabled) {
  <button class="sidenav-option menu d-flex align-items-center ps-3 pe-1" (click)="onButtonClick($event)">
    <anduin-icon class="pe-2" [name]="option().icon" />
    <span class="label flex-grow-1">{{ option().label }}</span>
    <anduin-icon
      name="more-horizontal"
      #menuTriggerIcon
      class="pe-2"
      [matMenuTriggerFor]="sidenavOptionMenu"
      (menuClosed)="handleMenuClosed()"
      (menuOpened)="handleMenuOpened()"
      height="12"
      width="12"
    />
    <mat-menu #sidenavOptionMenu="matMenu" [overlapTrigger]="true" xPosition="after" yPosition="above">
      @for (menuOption of menuOptions(); track menuOption.label) {
        @switch (menuOption.type) {
          @case ('link') {
            <a [href]="menuOption.link" [target]="menuOption.target ?? ''" mat-menu-item>
              <span>{{ menuOption.label }}</span>
            </a>
          }
          @case ('action') {
            <button (click)="menuOption.action()" mat-menu-item>
              <span>{{ menuOption.label }}</span>
            </button>
          }
        }
      }
    </mat-menu>
  </button>
}
